<template>
  <div>CasterLog</div>
</template>

<script>
export default {
  name: 'CasterLog',
}
</script>
